import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="app">
      <div className="container">
        <h1>Weather Search Engine</h1>
        <Weather defaultCity="Hong Kong" />
      </div>
      <span className="footer">
        <a
          href="https://github.com/emishi516/weather-app-react"
          target="_blank"
          rel="noreferrer"
        >
          Open-source code
        </a>{" "}
        by Ds
      </span>
    </div>
  );
}
